import * as React from "react"

// Styles
import "./_block-text.scss"

// Components
import { Section, Container } from "../StyledComponents/layoutComponentStyles"
import PortableText from "@sanity/block-content-to-react"
import { postSerializer } from "../../utils/blockContentSerializer"
import { $desktop } from "../../utils/breakpoints"

// Animations

interface BlockTextProps {
  module: any
}

/*









*/

const BlockText: React.FunctionComponent<BlockTextProps> = ({ module }) => {
  return (
    <Section>
      <Container fourteenClm>
        <div className='c-post__text'>
          <PortableText blocks={module._rawContent} serializers={postSerializer} projectId={"vjjaejga"} dataset={"production"} />
        </div>
      </Container>
    </Section>
  )
}

export default BlockText
